import { record } from 'rrweb';
import { BaseInstrumentation, VERSION } from '@grafana/faro-core';
import { defaultReplayInstrumentationOptions } from './const';
const faroSessionReplayEventName = 'faro.session_recording.event';
export class ReplayInstrumentation extends BaseInstrumentation {
    constructor(options = {}) {
        super();
        this.name = '@grafana/faro-instrumentation-replay';
        this.version = VERSION;
        this.stopFn = null;
        this.isRecording = false;
        this.options = defaultReplayInstrumentationOptions;
        this.options = Object.assign(Object.assign({}, defaultReplayInstrumentationOptions), options);
    }
    initialize() {
        if (this.isRecording) {
            this.logWarn('Session replay is already running');
            return;
        }
        this.startRecording();
    }
    startRecording() {
        try {
            const opts = {
                emit: (event, isCheckout) => {
                    this.handleEvent(event, isCheckout);
                },
                checkoutEveryNms: 300000, // 5 minutes
                recordCrossOriginIframes: this.options.recordCrossOriginIframes,
                maskAllInputs: this.options.maskAllInputs,
                maskInputOptions: this.options.maskInputOptions,
                maskTextSelector: this.options.maskTextSelector,
                blockSelector: this.options.blockSelector,
                ignoreSelector: this.options.ignoreSelector,
                recordCanvas: this.options.recordCanvas,
                collectFonts: this.options.collectFonts,
                inlineImages: this.options.inlineImages,
                recordDOM: true,
                inlineStylesheet: this.options.inlineStylesheet,
                errorHandler: (err) => {
                    this.logError('Error occurred during session replay', err);
                },
            };
            const stop = record(opts);
            if (stop) {
                this.stopFn = stop;
            }
            this.isRecording = true;
            this.logDebug('Session replay started');
        }
        catch (err) {
            this.logWarn('Failed to start session replay', err);
        }
    }
    handleEvent(event, _isCheckout) {
        try {
            // Apply beforeSend transformation if provided
            let processedEvent = event;
            if (this.options.beforeSend) {
                processedEvent = this.options.beforeSend(event);
                if (processedEvent === null || processedEvent === undefined) {
                    return;
                }
            }
            this.api.pushEvent(faroSessionReplayEventName, {
                event: JSON.stringify(processedEvent),
            });
        }
        catch (err) {
            this.logWarn(`Failed to push ${faroSessionReplayEventName} event`, err);
        }
    }
    destroy() {
        if (this.stopFn) {
            this.stopFn();
            this.stopFn = null;
        }
        this.isRecording = false;
        this.logDebug('Session replay stopped');
    }
}
//# sourceMappingURL=instrumentation.js.map